/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateCsvInput = {
    id: string;
    clientMutationId?: string | null;
};
export type createCsvMutationVariables = {
    input: CreateCsvInput;
};
export type createCsvMutationResponse = {
    readonly createCsv: {
        readonly presignedGetUrl: string | null;
    } | null;
};
export type createCsvMutation = {
    readonly response: createCsvMutationResponse;
    readonly variables: createCsvMutationVariables;
};



/*
mutation createCsvMutation(
  $input: CreateCsvInput!
) {
  createCsv(input: $input) {
    presignedGetUrl
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCsvPayload",
    "kind": "LinkedField",
    "name": "createCsv",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "presignedGetUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createCsvMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createCsvMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0201fee97b8d2cc2d53d17dd2c307ece",
    "id": null,
    "metadata": {},
    "name": "createCsvMutation",
    "operationKind": "mutation",
    "text": "mutation createCsvMutation(\n  $input: CreateCsvInput!\n) {\n  createCsv(input: $input) {\n    presignedGetUrl\n  }\n}\n"
  }
};
})();
(node as any).hash = '0a0fab65f3fbd5d2795738464e7ceb23';
export default node;
